import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { CheckboxGroupField, WorkplaceCheckboxGroupField, SelectField, EnumSelectField } from "components/mui/Fields";
import { MultiSelectField, RadioGroupForm } from "componentLibrary";
import WPADateField from "components/mui/Fields/Fields/DateField/WPADateField";
import { jsx as _jsx } from "react/jsx-runtime";
export var FilterType = {
  SINGLE_SELECT: "single_select",
  ENUM_SINGLE_SELECT: "enum_single_select",
  MULTIPLE_SELECT: "multiple_select",
  CHECKBOX_MULTI_SELECT: "checkbox_multi_select",
  WPA_DATE_SELECT: "wpa_date_select",
  CHECKBOX_POST_DISABLED_MULTI_SELECT: "checkbox_post_disabled_multi_select",
  RADIO_SELECT: "radio_select"
};
var FilterComponent = function FilterComponent(_ref) {
  var config = _ref.config,
    filterValues = _ref.filterValues,
    handleOnChange = _ref.handleOnChange;
  var type = config.type,
    label = config.label,
    filterKey = config.filterKey,
    options = config.options;
  switch (type) {
    case FilterType.ENUM_SINGLE_SELECT:
      {
        var _config$excludedValue;
        var value = filterValues === null || filterValues === void 0 ? void 0 : filterValues[filterKey];
        return /*#__PURE__*/_jsx(EnumSelectField, {
          name: filterKey,
          label: label,
          enumObject: options,
          onChange: function onChange(event) {
            return handleOnChange(event, false);
          },
          fullWidth: true,
          value: value,
          excludedValues: (_config$excludedValue = config.excludedValues) !== null && _config$excludedValue !== void 0 ? _config$excludedValue : []
        });
      }
    case FilterType.SINGLE_SELECT:
      {
        var _value = filterValues === null || filterValues === void 0 ? void 0 : filterValues[filterKey];
        return /*#__PURE__*/_jsx(SelectField, {
          name: filterKey,
          label: label,
          options: options,
          onChange: function onChange(event) {
            return handleOnChange(event, false);
          },
          fullWidth: true,
          value: _value,
          showBlank: true,
          displayEmpty: true,
          placeholder: config.placeholder
        });
      }
    case FilterType.MULTIPLE_SELECT:
      {
        var _filterValues$filterK;
        var selectedValues = (_filterValues$filterK = filterValues === null || filterValues === void 0 ? void 0 : filterValues[filterKey]) !== null && _filterValues$filterK !== void 0 ? _filterValues$filterK : [];
        return /*#__PURE__*/_jsx(MultiSelectField, {
          name: filterKey,
          label: label,
          options: options,
          selectedValues: selectedValues,
          fullWidth: true,
          onChange: function onChange(event) {
            return handleOnChange(event, true);
          }
        });
      }
    case FilterType.CHECKBOX_MULTI_SELECT:
      {
        var _filterValues$filterK2;
        var _selectedValues = (_filterValues$filterK2 = filterValues === null || filterValues === void 0 ? void 0 : filterValues[filterKey]) !== null && _filterValues$filterK2 !== void 0 ? _filterValues$filterK2 : [];
        return /*#__PURE__*/_jsx(CheckboxGroupField, _objectSpread({
          label: label,
          selectedValues: _selectedValues,
          handleOnChange: handleOnChange,
          options: options,
          filterKey: filterKey,
          hasAllSelect: true
        }, config));
      }
    case FilterType.CHECKBOX_POST_DISABLED_MULTI_SELECT:
      {
        var _filterValues$filterK3;
        var _selectedValues2 = (_filterValues$filterK3 = filterValues === null || filterValues === void 0 ? void 0 : filterValues[filterKey]) !== null && _filterValues$filterK3 !== void 0 ? _filterValues$filterK3 : [];
        return /*#__PURE__*/_jsx(WorkplaceCheckboxGroupField, _objectSpread({
          label: label,
          selectedValues: _selectedValues2,
          handleOnChange: handleOnChange,
          options: options,
          filterKey: filterKey,
          hasAllSelect: true
        }, config));
      }
    case FilterType.WPA_DATE_SELECT:
      {
        var _value2 = filterValues === null || filterValues === void 0 ? void 0 : filterValues[filterKey];
        return /*#__PURE__*/_jsx(WPADateField, {
          label: label,
          onSelectedDateRangeFilterChanged: handleOnChange,
          defaultInputText: config === null || config === void 0 ? void 0 : config.defaultInputText,
          selectedDateRangeFilter: _value2 === null || _value2 === void 0 ? void 0 : _value2.dateRangeFilter
        });
      }
    case FilterType.RADIO_SELECT:
      {
        var _value3 = filterValues === null || filterValues === void 0 ? void 0 : filterValues[filterKey];
        return /*#__PURE__*/_jsx(RadioGroupForm, {
          name: filterKey,
          label: label,
          options: options,
          value: _value3,
          fullWidth: true,
          showNoneOption: true,
          onChange: function onChange(event) {
            return handleOnChange(event, false);
          }
        });
      }
    default:
      return null;
  }
};
export default FilterComponent;